<div class="top-section">
  <h6 class="heading mb-0">{{ ss.t('unscheduled_titleTopBar') }}</h6>
  <div class="flex">
    <app-svg name="more" class="more-icon ri-me-6" [matMenuTriggerFor]="infoMenu" #meInputTrigger="matMenuTrigger"
      role="button" [color]="ss.theme().color12"></app-svg>
    <mat-menu yPosition="above" xPosition="before" #infoMenu="matMenu" class="me-menu info-menu me-min-w-200px">
      <button mat-menu-item class="" (click)="$event.stopPropagation()">
        <div class="w-full">
          <app-input-dropdown [signal]="unscheduleShowSignal" [config]="entityShowConfig()"
            [multiple]="true" textClass="text-12-400"
            (select)="ss.updateView()" [hiddenValues]="hidenValues" [placeholder]="ss.t('common_kebabMenuViewConfiguration')"></app-input-dropdown>
        </div>
      </button>
    </mat-menu>
    <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
  </div>
</div>
<div class="filter-block h-auto filtered">
  <button class="btn btn-filter btn-toggle me-2" [ngClass]="{'active': filterType() === 'all' }"
    (click)="filterType.set('all')">{{ ss.t('common_all') }}</button>
  <button class="btn btn-filter btn-toggle me-2"
    [ngClass]="{'active': filterType() === 'incomplete' }"
    (click)="filterType.set('incomplete')">{{ ss.t('common_habitIncomplete') }}</button>
  <button class="btn btn-filter btn-toggle me-2"
    [ngClass]="{'active': filterType() === 'completed' }"
    (click)="filterType.set('completed')">{{ ss.t('common_completed') }}</button>
  <button class="btn btn-filter btn-toggle me-2"
    [ngClass]="{'active': filterType() === 'skipped' }"
    (click)="filterType.set('skipped')">{{ ss.t('common_skipped') }}</button>
</div>
<div class="todos-block">
  <ng-container *ngFor="let todo of unscheduledTodos(); let i = index; trackBy: trackByForEntry;">
    <app-todo-block class="ri-bb-2 entity-block"
      [blockClass]="'ri-px-4 ri-py-3'" [show]="viewSettings.unscheduleShow()" [entry]="todo"
      [descriptionType]="viewSettings.unscheduleDescriptionType()" [isLabel]="false"></app-todo-block>
  </ng-container>

  <div class="no-result-block h-full flex items-center justify-center flex-col" *ngIf="unscheduledTodos().length === 0">
    <app-svg name="searchPlaceholder" [color]="ss.theme().color1"></app-svg>
    <p class="text-16-400 color-8 mb-0 ri-pt-4">{{ ss.t('common_noResultFound') }}</p>
  </div>
</div>